"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IsoCountrySubdivisionCode = exports.IsoCountryCode = void 0;
const type_utils_1 = require("@transcend-io/type-utils");
const iso3166_1_1 = require("./isoConstants/iso3166-1");
const iso3166_2_1 = require("./isoConstants/iso3166-2");
/**
 * gets a typed Dictionary (identical key/values) from a source lookup object
 *
 * @param source - the source lookup
 * @returns the typed dictionary
 */
function getDictFromKeys(source) {
    return Object.fromEntries(Object.keys(source).map((code) => [code, code]));
}
/**
 * Country Code taken from https://github.com/umpirsky/country-list/blob/master/data/en/country.json
 */
exports.IsoCountryCode = (0, type_utils_1.makeEnum)(getDictFromKeys(iso3166_1_1.ISO_31661));
/**
 * Country subdivisions taken from taken from https://github.com/wooorm/iso-3166/blob/main/2.js
 */
exports.IsoCountrySubdivisionCode = (0, type_utils_1.makeEnum)(getDictFromKeys(iso3166_2_1.ISO_31662));
//# sourceMappingURL=isoRegion.js.map